import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { Button, ButtonAsType } from '@motorway/mw-highway-code';

import { Content } from 'LegacySBCRA/Content/Content';

import sign from '../../../../client/assets_seller/sign.svg';
import Texts from '../../../texts.json';

import styles from './Error.scss';

const LocalT = new MDText(Texts);

interface ButtonProps {
  element: ButtonAsType;
  to: string;
}

interface ErrorProps {
  buttonLabel: string;
  buttonProps?: ButtonProps;
  detail: React.ReactNode;
  number: string;
  showSign?: boolean;
  testid?: string;
  title: string;
}

const ErrorComponent: React.FC<ErrorProps> = ({
  buttonLabel,
  buttonProps = { element: Link, to: '/' },
  detail = '',
  number,
  showSign = true,
  testid = '',
  title,
}) => (
  <Content className={styles.view} data-testid={['error', testid || number || 'unknown'].join('-')} element="section">
    {showSign && (
      <div className={styles.sign}>
        <img alt="sign" src={sign} />
        <div className={styles.asset}>
          <span className={styles.char}>M</span>
          <span className={styles.number}>{number}</span>
        </div>
      </div>
    )}
    <h2 className={styles.title}>{LocalT.translate(title)}</h2>
    <p className={styles.detail}>{detail}</p>
    <div className={styles.button}>
      <Button
        fullWidth
        as={buttonProps.element}
        icon="chevron"
        label={LocalT.translate(buttonLabel)}
        {...(buttonProps.element === Link ? { to: buttonProps.to || '/' } : {})}
      />
    </div>
  </Content>
);

export default ErrorComponent;
